import React, { useEffect, useState } from 'react';

import { useNavigationItems, useTinyBanner } from '@hooks/api';

import { Logo } from './assets';

import Header from './Header';

export default function HeaderContainer() {
  const { navigationItems } = useNavigationItems();
  const { tinyBanner } = useTinyBanner();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    const getLoginStatus = async () => {
      const response = await fetch('/v1.1/status/', {
        method: 'HEAD'
      });

      setIsLoggedIn(
        response.headers.get('X-Authorized').toLowerCase?.() === 'true'
      );

      setFirstName(response.headers.get('X-User-First-Name') || '');
    };

    getLoginStatus();
  }, []);

  return (
    <Header
      navigationItems={navigationItems}
      tinyBanner={tinyBanner}
      headerLogo={
        <a href="/" className="flex flex-none items-center focus:outline-none">
          <Logo className="h-[24px] w-[118px] shrink-0" />
        </a>
      }
      isLoggedIn={isLoggedIn}
      firstName={firstName}
      options={{
        locale: window?.config?.iso_language_code || 'en-GB'
      }}
    />
  );
}
